import { useTrackingGeneral, type UseTrackingGeneralReturn } from './tracking/general';
import { useTrackingSdp, type UseTrackingSdpReturn } from './tracking/sdp';
import { wrapTrackFunctions } from './tracking/shared';
import { useTrackingSignup, type UseTrackingSignupReturn } from './tracking/signup';
import { useTrackingSlp, type UseTrackingSlpReturn } from './tracking/slp';

export type UseTrackingReturn = UseTrackingGeneralReturn & UseTrackingSdpReturn & UseTrackingSlpReturn & UseTrackingSignupReturn;

export const useTracking = (): UseTrackingReturn => {
    const generalTracking = useTrackingGeneral();
    const sdpTracking = useTrackingSdp();
    const slpTracking = useTrackingSlp();
    const signupTracking = useTrackingSignup();

    return wrapTrackFunctions({
        ...generalTracking,
        ...sdpTracking,
        ...slpTracking,
        ...signupTracking,
    });
};
